import React from "react";
import { Card } from "../card";

const TeacherDashboard = () => {
  return (
    <Card cardTitle="My students">
      {/*     <ListTable /> */}
      <></>
    </Card>
  );
};
export default TeacherDashboard;
